import { SingleMemberFirmCreationType } from '@bupa-kkv/features/company-creation/types';
import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { setShowEstablishedMessage } from '../api/show-established-message.api';

export const useSetShowEstablishedMessage = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      showMessage,
      type,
    }: {
      showMessage: boolean;
      type: SingleMemberFirmCreationType;
    }) => setShowEstablishedMessage(showMessage, type),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey:
          queryKeyStore.companyCreation.selfEmploymentCreations.queryKey,
      }),
  });
};
